// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"32b0be15","159":"551b9368","223":"32ccb650","393":"e9ac818a","931":"afeb1ef0"}[chunkId] + ".chunk.js";
};